import React from 'react';
import { Route } from 'react-router';

import { LoadableSquadsAcceptInvitePage } from './helpers/loadables';

export default (
  <>
    {/* Group Challenges Invite Fallback Route */}
    <Route
      path="squads/acceptinvite/:inviteCode"
      component={LoadableSquadsAcceptInvitePage}
      whiteBackground
    />
  </>
);
